"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Epsilon Section Focus
 */
var EpsilonSectionFocus = /** @class */ (function () {
    /**
     * Class constructor
     */
    function EpsilonSectionFocus() {
        var self = this;
        wp.customize.preview.bind('epsilon-section-focused', _.debounce(function (object) {
            if (object === void 0) { object = { index: 0, closed: true }; }
            if (object.closed) {
                return;
            }
            self.scrollTo(object.index);
        }, 300));
    }
    /**
     * Scrolls into view
     * @param {number} index
     */
    EpsilonSectionFocus.prototype.scrollTo = function (index) {
        if (index === void 0) { index = 0; }
        var selector = $('[data-section="' + index + '"]'), distance;
        distance = this.calculateOffsets(selector);
        $('html, body').animate({
            scrollTop: distance
        }, 500);
    };
    /**
     * Returns a number ( distance from top to div )
     * @param {JQuery} selector
     * @returns {number}
     */
    EpsilonSectionFocus.prototype.calculateOffsets = function (selector) {
        var offset = selector.offset();
        if (typeof offset !== 'undefined' && offset.hasOwnProperty('top')) {
            return offset.top;
        }
        return 0;
    };
    return EpsilonSectionFocus;
}());
exports.EpsilonSectionFocus = EpsilonSectionFocus;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/previewer/section-focus/section-focus.ts
// module id = 35
// module chunks = 1